import { AxiosInstance } from 'axios'
import type { FolderTree } from '@dc-shared-web/hooks/api/folder/types'

type GetFolderTreeParams = {
  currentTeamUuid: string
  folderUuid?: string
  projectUuid?: string
}

export const fetchFolderTree = async (
  apiClient: AxiosInstance,
  params: GetFolderTreeParams
): Promise<FolderTree[]> => {
  const { data } = await apiClient.get(`/api/folders/tree`, {
    params: {
      office_uuid: params.currentTeamUuid,
      sortBy: 'name',
    },
  })
  return data
}
